export default {
  // 標題
  input: "輸入",

  // 按鈕
  collapseAll: "收起全部",
  viewAll: "查看全部",

  // 消息提示
  copySuccess: "複製成功",
};
